import {styled, Tab, Tabs} from '@mui/material'
import {Colors} from 'appearance'

export const StyledTabs = styled((props) => (
    <Tabs
        {...props}
        TabIndicatorProps={{
            children: <span className="MuiTabs-indicatorSpan" />,
        }}
    />
))({})

export const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
    ({theme}) => ({
        textTransform: 'none',
        flexGrow: 0,
        padding: 16,
        alignItems: 'flex-start',
        fontSize: 16,
        '&:hover': {
            color: Colors.PRIMARY_HOVER,
            opacity: 1,
        },
        '&.Mui-selected': {
            color: Colors.PRIMARY_COLOR,
            fontWeight: 'bold',
        },
    })
)
